export enum EPasswordType {
  PASS_MAIN,
  PASS_INVESTOR,
  PASS_API
}

// Account Link APIs params
export interface IAccountLinkParams {
  metatraderId: number;
  password: string;
}

export interface IAccountLinkRemoveParams {
  metatraderId: number;
  passwordType: EPasswordType;
  serverId?: number; // only required if OMS
}
